import React from "react";
import { Box, Typography, useMediaQuery, useTheme, Grid } from "@mui/material";
import { Title } from "../../components/Title";
import { useTranslation } from "react-i18next";
import gallery6 from "../../assets/gallery/gallery6.jpg";
import { Link } from "react-router-dom";

const Location = () => {
  const { t } = useTranslation("translation");
  const Theme = useTheme();
  const isMobile = useMediaQuery(Theme.breakpoints.down("md"));

  return (
    <Box>
      <Title label={t("location")} />
      {/*<Typography>{t("locationAddress")}</Typography>*/}
      <Grid
        container
        sx={(theme) => ({
          [theme.breakpoints.up("md")]: {
            marginTop: "30px",
          },
        })}
      >
        <Grid item xs={12} md={7}>
          <img
            src={gallery6}
            height={isMobile ? "250px" : "400px"}
            alt="gallery7"
            style={{ boxShadow: "0px 5px 5px grey" }}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={2}
          display="flex"
          justifyContent="flex-start"
          alignItems="center"
        >
          <Box
            sx={(theme) => ({
              [theme.breakpoints.down("md")]: {
                marginTop: "30px",
              },
            })}
          >
            <Typography variant="h5">Dune du Pilat</Typography>
            <Typography variant="h5">
              999 Av. de Biscarrosse, 33260 La-Teste-de-Buch
            </Typography>
            <Typography variant="h5">7j/7j - 24h/24h</Typography>
            <Typography variant="h5">0627523632</Typography>
            <Link
              target="_blank"
              to="https://www.google.com/maps/place/Glaces+%26+Smoothies+By+Bio+Yum+Yum/@44.5982082,-1.2035235,17z/data=!3m1!4b1!4m6!3m5!1s0xd549d2a91050f17:0xdf54eba053990114!8m2!3d44.5982082!4d-1.2009486!16s%2Fg%2F11vdmwr9hf?entry=ttu&g_ep=EgoyMDI1MDMyNC4wIKXMDSoASAFQAw%3D%3D"
            >
              <Typography variant="h5" marginTop={2}>
                Où nous trouver
              </Typography>
            </Link>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export { Location };
